<!--获取月票收费流水信息-->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "2KKN885S",
          "operateTimeFrom": "20200101000000",
          "operateTimeTo": "20200401235959",
          "carNo": "粤A12345",
          "pageNum": 1,
          "pageSize": 10,
        },
        responseCode: {
          "data": {
            "currentCount": 1,
            "recordList": [
              {
                "billType": 0,
                "carNo": "京A12345",
                "favorPrice": 5,
                "invoiceStatus": 0,
                "monthTicketTypeId": 677,
                "monthTicketTypeName": "0310KAIYU测试月票01",
                "operateTime": 1583825746000,
                "operator": "System",
                "originPrice": 10,
                "owner": "王五11",
                "parkList": [
                  {
                    "parkCode": "2KKN885S",
                    "parkName": "昌俊停车场"
                  }
                ],
                "payMode": 4,
                "payModeRemark": "微信支付",
                "payOrigin": 7,
                "payOriginRemark": "智慧停车",
                "phone": "18000000000",
                "refundValue": 0,
                "reliefValue": 5,
                "remark": "新增预约VIP月票",
                "thirdBillCode": "wdl201904250001",
                "timePeriodList": [
                  {
                    "endTime": "20200417235959",
                    "startTime": "20200310000000"
                  }
                ]
              }
            ]
          },
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台查询线上月票支付信息",
          t_url: this.commonUrls.test + "getOnlineMonthTicketPayment",
          p_url: this.commonUrls.prod + "getOnlineMonthTicketPayment",
          precondition: "无",
          fitSystem: "云停车场,传统车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
              { info1: 'operateTimeFrom', info2: '是', info3: 'String', info4: '操作时间开始，格式：yyyyMMddHHmmss' },
              { info1: 'operateTimeTo', info2: '是', info3: 'String', info4: '操作时间结束，格式：yyyyMMddHHmmss，操作时间间隔不能大于3个月' },
              { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码' },
              { info1: 'billType', info2: '否', info3: 'Integer', info4: '月票缴费类型，0 开通，1 续费，2 退费，默认所有' },
              { info1: 'monthTicketTypeId', info2: '否', info3: 'Long', info4: '月票类型id' },
              { info1: 'invoiceStatus', info2: '否', info3: 'Integer', info4: '是否开发票，0 未开票，1 纸质票， 2 电子票' },
              { info1: 'invoiceNo', info2: '否', info3: 'String', info4: '发票号码' },
              { info1: 'payOrigin', info2: '否', info3: 'Integer', info4: '支付来源，<url>参考附录:/Api/appendixData#appendixData_1</url>' },
              { info1: 'payMode', info2: '否', info3: 'Integer', info4: '支付方式，<url>参考附录:/Api/appendixData#appendixData_0</url>' },
              { info1: 'operator', info2: '否', info3: 'String', info4: '操作员' },
              { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
              { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多100条' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'currentCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
              { info1: 'total', info2: '是', info3: 'Integer', info4: '总数' },
              { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' },
            ]
          },{
            titleName: 'recordList',
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkList', info2: '是', info3: 'JSONArray', info4: '适用停车场列表' },
              { info1: 'monthTicketTypeId', info2: '是', info3: 'Long', info4: '月票类型id' },
              { info1: 'monthTicketTypeName', info2: '是', info3: 'String', info4: '月票类型名称' },
              { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码' },
              { info1: 'owner', info2: '是', info3: 'String', info4: '车主姓名' },
              { info1: 'phone', info2: '是', info3: 'String', info4: '手机号码' },
              { info1: 'billType', info2: '否', info3: 'Integer', info4: '月票缴费类型，0 开通，1 续费，2 退费' },
              { info1: 'timePeriodList', info2: '是', info3: 'JSONArray', info4: '有效时间段列表' },
              { info1: 'originPrice', info2: '是', info3: 'Decimal', info4: '票原价（总金额），单位元' },
              { info1: 'favorPrice', info2: '是', info3: 'Decimal', info4: '票折后价（总支付金额），单位元' },
              { info1: 'reliefValue', info2: '是', info3: 'Decimal', info4: '总优惠金额，单位元' },
              { info1: 'refundValue', info2: '是', info3: 'Decimal', info4: '退款金额，单位元' },
              { info1: 'payOrigin', info2: '是', info3: 'Integer', info4: '支付来源，<url>参考附录:/Api/appendixData#appendixData_1</url>' },
              { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
              { info1: 'payMode', info2: '是', info3: 'Integer', info4: '支付方式，<url>参考附录:/Api/appendixData#appendixData_0</url>' },
              { info1: 'payModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
              { info1: 'billCode', info2: '否', info3: 'String', info4: '订单号' },
              { info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方订单号' },
              { info1: 'operator', info2: '是', info3: 'String', info4: '操作员' },
              { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间，yyyyMMddHHmmss' },
              { info1: 'remark', info2: '是', info3: 'String', info4: '备注' },
              { info1: 'invoiceStatus', info2: '否', info3: 'Integer', info4: '是否开发票，0 未开票，1 纸质票， 2 电子票' },
              { info1: 'invoiceNo', info2: '否', info3: 'String', info4: '发票号码' },
              { info1: 'bankType', info2: '否', info3: 'String', info4: '付款银行(一点停微信支付才有)' },
            ]
          },{
            titleName: 'parkList',
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '适用停车场编号' },
              { info1: 'parkName', info2: '是', info3: 'String', info4: '适用停车场名称' },
            ]
          },{
            titleName: 'timePeriodList',
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间，yyyyMMddHHmmss' },
              { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，yyyyMMddHHmmss' }
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getOnlineMonthTicketPayment.vue